<div class="rounded-2xl border border-surface-300 p-4">
    <div class="flex flex-row justify-between items-center text-lg font-bold">
        <div class="flex flex-row gap-4 items-center ">
            <i class="pi pi-wallet text-lg font-bold" />
            Uw huidig {{serviceTitle}}-saldo
        </div>
        <div>{{ formatCurrency(availableAmount) }}</div>
    </div>
</div>
